import { ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import { QButton, QModal, QModalActions, QModalContent, QTypography } from '@kw/quokka-ui';

interface OrganizationSettingsDialogProps {
  id: string;
  open: boolean;
  title: string;
  body: ReactNode;
  primaryLabel: string;
  onPrimary: () => void;
  onClose: () => void;
  showCancel?: boolean;
  isSaving?: boolean;
}

export const OrganizationSettingsDialog = ({
  id,
  open,
  title,
  body,
  primaryLabel,
  onPrimary,
  onClose,
  showCancel = false,
  isSaving = false,
}: OrganizationSettingsDialogProps) => {
  const titleId = `${id}-title`;

  return (
    <QModal
      open={open}
      onClose={onClose}
      aria-labelledby={titleId}
      maxWidth={false}
      PaperProps={dialogPaperProps}
      title={
        <DialogHeader>
          <DialogTitle id={titleId} variant="h3Medium">
            {title}
          </DialogTitle>
        </DialogHeader>
      }
      content={
        <DialogContent>
          <DialogDescription variant="bodyRegular">{body}</DialogDescription>
        </DialogContent>
      }
      actions={
        <DialogActions>
          {showCancel && (
            <QButton variant="outlined" onClick={onClose} disabled={isSaving}>
              Cancel
            </QButton>
          )}
          <QButton variant="filled" onClick={onPrimary} disabled={isSaving}>
            {isSaving ? 'Saving…' : primaryLabel}
          </QButton>
        </DialogActions>
      }
    />
  );
};

const dialogPaperProps = {
  sx: {
    width: '568px',
    minWidth: 0,
    maxWidth: 'calc(100vw - 48px)',
    borderRadius: '12px',
    overflow: 'hidden',
    '& .MuiDivider-root': {
      display: 'none',
    },
  },
};

const DialogHeader = styled('div')`
  padding: 26px 28px 0;
`;

const DialogTitle = styled(QTypography)`
  display: block;
  font-size: 18px;
  line-height: 25px;
  font-weight: 700;
`;

const DialogContent = styled(QModalContent)`
  padding: 10px 28px 0;
`;

const DialogDescription = styled(QTypography)`
  display: block;
  color: #52666d;
  font-size: 14px;
  line-height: 22px;
`;

const DialogActions = styled(QModalActions)`
  gap: 10px;
  padding: 24px 28px 22px;

  button {
    min-width: 90px;
  }
`;
